import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
}), 'TrendingDownTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TrendingDownTwoTone.js
// module id = 6923
// module chunks = 2